<template>
  <v-row>
    <v-col cols="12">
      <v-btn @click="previewForm" block>{{ isPreview ? 'Vissza a szerkesztéshez' : 'Mentés és előnézet' }}</v-btn>
    </v-col>
  </v-row>
  <div v-if="isPreview">
    <FormsComponent 
      :isPreview="true"
    />
  </div>
  <div v-if="!isPreview">
    <v-row>
      <v-col cols="6">
        <v-btn color="green" @click="postForm" block>Változtatások mentése</v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn color="red" @click="discardChanges" block>Változtatások eldobása</v-btn>
      </v-col>
    </v-row>
    <v-card>
      <v-slide-group>
        <v-slide-group-item v-for="(section, index) in form" :key="index">
          <v-btn
            @click="chooseForm(index)"
            :color="currentSection === index ? 'red' : 'white'"
          >
            {{ index + 1 }} Task - {{ section.name }}
          </v-btn>
        </v-slide-group-item>
        <v-slide-group-item>
          <v-btn @click="openDialog" text>ÚJ</v-btn>
          <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
              <v-card-title>Új szekció</v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="sectionName"
                  label="Szekció neve"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" @click="addNewSection">Létrehozás</v-btn>
                <v-btn @click="closeDialog">Mégsem</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-slide-group-item>
      </v-slide-group>
    </v-card>
    <v-btn v-if="currentSection >= 0" color="red" width="100%" @click="deleteSection()">Szekció törlése</v-btn>
  
    <v-card v-if="form.length > 0 && form[currentSection]">
      <draggable :list="form[currentSection].children" item-key="name">
        <template #item="{ element, index }">
          <v-card class="mb-3">
            <v-card-title >
              <div class="text-truncate">
                <span v-if="duplicateIndices.includes(element?.name)" class="warning">Többszörös név, kérem javítsa!</span>
                <div><h4>
                  {{ convertToText(element.type) }} - {{ element.name }}
                </h4>
                  {{ element.text }}</div>
              </div>
              <div>
                <v-btn icon @click="editFormElement(index)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon @click="deleteFormElement(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </v-card-title>
          </v-card>
        </template>
        <template #header>
          <v-btn @click="openFormAddDialog" >Hozzáadás</v-btn>
        </template>
      </draggable>
    </v-card>
    <v-dialog v-model="formDialog" max-width="500px">
      <v-card>
        <v-card-title>Mező {{ editMode ? 'Szerkesztése' : 'Létrehozása' }}</v-card-title>
        <v-card-text>
          <v-select
            v-model="selectedFieldType"
            :items="fieldTypes"
            label="Mező típus kiválasztása"
            outlined
            dense
          ></v-select>
          <ComponentProvider
            :type="selectedFieldType"
            :baseValue="editMode ? form[currentSection].children[editIdx] : {}"
            @formAddEvent="formEvent"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="addToForm">{{
            editMode ? 'Mentés' : 'Hozzáadás'
          }}</v-btn>
          <v-btn @click="closeFormDialog">Mégsem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <save-dialog :showdialog="isSaveDialogVisible" @dialogChange="handleDialogChange"/>
</template>

<script>
import { defineComponent } from 'vue'
import draggable from 'vuedraggable'
import ComponentProvider from '../components/formCreateComponents/ComponentProvider.vue'
import SaveDialog from '../components/SaveDialog.vue'
import {
  uploadImage,
  getFormByCompetitionId,
  putFormDescriptor,
  postFormDescriptor,
  deleteFormDescriptor,
} from '../services/adminServices'
import FormsComponent from '../components/FormsComponent.vue'
import { v4 as uuidv4 } from 'uuid'



export default defineComponent({
  name: `InfoPage`,
  components: {
    draggable,
    ComponentProvider,
    SaveDialog,
    FormsComponent,
  },
  props: {
    competitionId: String,
  },
  created() {
    this.getData()
  },
  data() {
    return {
      duplicateIndices: [],
      isSaveDialogVisible: false,
      inputTypes: [
        'checkbox',
        'checkboxWithText',
        'largeText',
        'multiCheckbox',
        'multiTextBox',
        'textbox',
        'institute'
      ],
      fieldTypes: [
        {
          title: 'Radio gomb',
          value: 'checkbox',
        }, {
          title: 'Radio gomb szöveggel',
          value: 'checkboxWithText',
        }, {
          title: 'Kép',
          value: 'img',
        }, {
          title: 'Esszé mező',
          value: 'largeText',
        }, {
          title: 'Markdown csak olvasós',
          value: 'md',
        }, {
          title: 'Checkbox',
          value: 'multiCheckbox',
        }, {
          title: 'Intézmény választó',
          value: 'institute',
        }, {
          title: 'Szöveg',
          value: 'text',
        }, {
          title: 'Szöveges mező',
          value: 'textbox',
        }, {
          title: 'Többszörös szöveges mező',
          value: 'multiTextBox',
        }, 
      ],
      form: [],
      currentSection: -1,
      dialog: false,
      formDialog: false,
      sectionName: '',
      editIdx: -1,
      selectedFieldType: null,
      newField: {},
      editMode: false,
      isPreview: false,
    }
  },
  methods: {
    checkDuplicates() {
      this.duplicateIndices = this.findDuplicateNames(this.form[this.currentSection].children);
    },
    findDuplicateNames(arr) {
      const nameSet = new Set();
      const duplicatesSet = new Set();

      arr?.forEach(obj => {
        if (nameSet.has(obj.name)) {
          duplicatesSet.add(obj.name);
        } else {
          nameSet.add(obj.name);
        }
      });
      return [...duplicatesSet]; // Convert Set to array
    },
    convertToText(text) {
      return (this.fieldTypes.find(e =>{ 
        return e.value === text})).title
    },
    async getData() {
      this.form = await getFormByCompetitionId(this.competitionId)
    },
    openFormAddDialog() {
      this.editMode = false
      this.selectedFieldType = null
      this.openFormDialog()
    },
    openFormDialog() {
      this.formDialog = true
      this.newField = {}
    },
    closeFormDialog() {
      this.formDialog = false
    },
    saveForm() {
      putFormDescriptor(this.form)
    },
    async uploadFile(data) {
      const formData = new FormData()
      formData.append('file', data.file)
      formData.append('name', uuidv4())
      formData.append('imageHeight', data.imageHeight)
      return await uploadImage(formData)
    },
    formEvent(data) {
      this.newField = data
    },
    async addToForm() {
      const name = this.newField?.name?.trim()
      if (name) {
        const conflict = this.form[this.currentSection].children.some((child, idx) => {
          if (this.editMode && idx === this.editIdx) return false
          return child?.name === name
        })
        if (conflict) {
          alert(`A "${name}" azonosító már létezik ebben a szekcióban. Kérem válasszon másikat.`)
          return
        }
      }
      if (this.editMode) {
        this.form[this.currentSection].children[this.editIdx] = this.newField
      } else {
        if (this.newField.file) {
          this.form[this.currentSection].children.push(
            await this.uploadFile(this.newField)
          )
          this.closeFormDialog()
          return
        }
        this.form[this.currentSection].children.push(this.newField)
      }
      this.closeFormDialog()
      this.checkDuplicates()
    },
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    async addNewSection() {
      if (this.sectionName.trim() === '') return // Don't add empty sections
      const id = await postFormDescriptor(this.$route.params.competitionId, {
        name: this.sectionName,
        section: this.form.length,
      })
      this.form.push({ id, name: this.sectionName, children: [] })
      this.sectionName = '' // Clear the input field
      this.closeDialog() // Close the dialog
    },
    chooseForm(index) {
      this.currentSection = index
    },
    editFormElement(index) {
      this.editIdx = index
      this.editMode = true
      this.selectedFieldType =
        this.form[this.currentSection].children[index].type
      this.openFormDialog()
    },
    deleteFormElement(index) {
      this.form[this.currentSection].children.splice(index, 1)
    },
    async postForm() {
      if(this.isPreview) return
      await putFormDescriptor(this.form)
      this.isSaveDialogVisible = true;
      setTimeout(() => {
        this.isSaveDialogVisible = false;
      }, 1500);
    },
    discardChanges() {
      this.getData()
    },
    handleDialogChange() {
      this.isSaveDialogVisible = false;
    },
    async previewForm() {
      await this.postForm()
      this.isPreview = !this.isPreview
    },
    async deleteSection(){
      if(this.currentSection < 0) return
      await deleteFormDescriptor(this.form[this.currentSection].id)
      this.form.splice(this.currentSection, 1)
      this.currentSection = -1
    }
  },
})
</script>

<style scoped>
.v-card {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 12px;
}
.mb-3 {
  margin-bottom: 1rem;
}
.d-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
